import { request } from '@/common/utils/request'
import { getLocation } from '@/common/utils/geo'

export function getLatestPerf(params) {
  // 绩效考核方案指标项下发
  return request
    .get({
      url: 'feidian.perf.getLatestPerf',
      params
    })
    .then(res => res.data)
}
export function getLatestPerfDetail(params) {
  // 绩效结果-最新绩效详情
  return request
    .get({
      url: 'feidian.perf.getLatestPerfDetail',
      params
    })
    .then(res => res.data)
}

let geo = null

function getGeo(force = false) {
  // force: 是否强制刷新geo
  return geo
    ? Promise.resolve(geo)
    : new Promise(async (resolve, reject) => {
      const geo = await getLocation()
      resolve(geo)
    })
}
